import React from 'react';
import './UserSetInfoPanel.scss';

const UserSetInfoPanel = ({ info, isLoading }) => {
const rows = [
    { label: '관리자 성명', value: info?.managerName },
    { label: '관리자 HP', value: info?.managerHp },
    { label: '학원명', value: info?.smsAcademyName },
    { label: '디비명', value: info?.dbName },
    { label: '사용여부', value: info?.useYn },
];

return (
    <div className="user-set-info-panel">
    {isLoading && <div className="user-set-info-status">조회중...</div>}
    {!isLoading && !info && <div className="user-set-info-status">회원을 선택하면 정보가 표시됩니다.</div>}
    {!isLoading && info && (
        <div className="user-set-info-grid">
        {rows.map((row) => (
            <div className="user-set-info-row" key={row.label}>
            <span className="user-set-info-label">{row.label}</span>
            <span className="user-set-info-sep"> : </span>
            <span className="user-set-info-value">{row.value || '-'}</span>
            </div>
        ))}
        </div>
    )}
    </div>
);
};

export default UserSetInfoPanel;
